module.exports = __webpack_public_path__ + "img/banner-service.869ebe6e.jpeg";